import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import {SmallTextDiv} from '../../modals';

const styles = {
  closeIcon: {'position': 'absolute', top: 0, 'right': '0', 'margin': '8px 5px 0 0'},
  labelStyle: {fontWeight: 700}
};

class MessageModal extends Component {
  modalStyle = {border: `3px solid #${this.props.secondaryColor}`};

  handleClose = () => {
    const {
      onClick,
      hideModal,
    } = this.props;

    if (onClick) {
      onClick();
      return;
    }

    hideModal();
  }

  render() {
    return (
      <Modal
        style={this.modalStyle}
        overlayTop={0}
        paddingTop={100}
        closeOnOutsideClick
        isOpened
        onClose={this.onCloseRequest}
      >
        <ModalWrapperDiv>
          <SmallTextDiv color={`#${this.props.secondaryColor}`}>{this.props.message}</SmallTextDiv>
          <ButtonsWrapperDiv>
            <RaisedButton
              onClick={this.handleClose}
              backgroundColor={`#${this.props.secondaryColor}`}
              labelColor="#FFF"
              label="Ok"
              labelStyle={styles.labelStyle}
            />
          </ButtonsWrapperDiv>
        </ModalWrapperDiv>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor
});

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => {
    dispatch(modal.hideModal());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);

MessageModal.defaultProps = {
  onClick: undefined,
};

MessageModal.propTypes = {
  onClick: PropTypes.func,
  hideModal: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};

const ModalWrapperDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;


const ButtonsWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/MessageModal/MessageModal.js